module.exports = __webpack_public_path__ + "static/media/thumbnail-robotFront.539bc564.png";